export class RequestAttendanceStatisticsDto {
  listEmp: any[];
  startDate: string;
  endDate: string;
  email: string;
  sendEmail: boolean;
  fullName: string;
  isCordova: boolean;
  isActive?: boolean;
  worklocationCodes: any[];
}

export class ResponseAttendanceStatisticsDto {
  message: string;
  data: string;
}

export class RequestDownloadExcelDto {
  listEmp: any[];
  startDate: Date;
  endDate: Date;
  companyId: number;
  email: string;
  fullName: string;
  sendEmail: boolean;
  isCordova: boolean;
  isActive?: boolean;
  worklocationCodes: any[];
  showUnknownStatus: boolean;
  allEmp?: boolean;
}

export class RequestDownloadPdfDto {
  listEmp: any[];
  startDate: Date;
  endDate: Date;
  companyId: number;
  email: string;
  fullName: string;
  sendEmail: boolean;
  isCordova: boolean;
  isActive?: boolean;
  worklocationCodes: any[];
  showUnknownStatus: boolean;
  allEmp?: boolean;
}

export class RequestSendEmailExcelDto {
  listEmp: any[];
  startDate: Date;
  endDate: Date;
  companyId: number;
  email: string;
  fullName: string;
  sendEmail: boolean;
  isCordova: boolean;
  isActive?: boolean;
  worklocationCodes: any[];
  showUnknownStatus: boolean;
}

export class ResponseSendEmailExcelDto {
  message: string;
  data?: any;
}

export class RequestSendEmailPdfDto {
  listEmp: any[];
  startDate: Date;
  endDate: Date;
  companyId: number;
  email: string;
  fullName: string;
  sendEmail: boolean;
  isCordova: boolean;
  worklocationCodes: any[];
}

export class ResponseSendEmailPdfDto {
  message: string;
  data?: any;
}

export class RequestPreviewDto {
  listEmp: any[];
  startDate: Date;
  endDate: Date;
  companyId: number;
  showUnknownStatus: boolean;
  email: string;
  fullName: string;
  sendEmail: boolean;
  isCordova: boolean;
  isActive?: boolean;
  worklocationCodes?: any[];
  allEmp?: boolean;
}






// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/attendance-report.dto.ts